function getReleaseNoteObject(
  date: string,
  version: string,
  newFeatures?: Record<string, string[]>,
  bugFixes?: Record<string, string[]>
) {
  return {
    [version]: {
      date,
      ...(newFeatures && { newFeatures }),
      ...(bugFixes && { bugFixes }),
    },
  };
}

function getReleaseNoteV2_20_0() {
  const date = '2022-09-28';
  const version = '2.20.0';
  const newFeatures = {
    'Employee Profile': ['HRs can create a Vyaguta profile for Hired employees.'],
    Holidays: ['HRs can set holidays on a country basis.'],
    Dashboard: ['Holiday will be shown on dashboard as per the location set in your Vyaguta profile.'],
    Footer: ['Added links to report bugs and provide feedback at the end of the page.'],
  };

  return getReleaseNoteObject(date, version, newFeatures);
}

function getReleaseNoteV2_21_0() {
  const date = '2022-11-17';
  const version = '2.21.0';
  const newFeatures = {
    Dashboard: [
      'HRs can create a Vyaguta profile for Hired employees.',
      "The dashboard now allows you to see the weekly amount of hours logged. So, don't forget to " +
        'log your worklog daily.',
      "The area to see Company's notices has been added in the dashboard. Although we are aware of " +
        'the hue, but hey that is how you will notice it. 😉',
    ],
    Profile: [
      "We have also added a section inside your profile page to list all the team member's that you " +
        "are responsible for. So, don't miss to check it out.",
    ],
  };

  return getReleaseNoteObject(date, version, newFeatures);
}

function getReleaseNoteV2_22_0() {
  const date = '2023-01-05';
  const version = '2.22.0';
  const newFeatures = {
    Profile: [
      'Leave Issuers, Team Managers, Project Managers, and Team Leads can now request to change the ' +
        'leave issuer of their team members from their profile.',
    ],
    'Leave Issuer': ['Status updates in leave issuer change requests will be notified via email.'],
  };

  return getReleaseNoteObject(date, version, newFeatures);
}

function getReleaseNoteV2_23_0() {
  const date = '2023-02-02';
  const version = '2.23.0';
  const newFeatures = {
    'List 0': [
      'Easy navigation for People Management team with merged tabs.',
      'The People Management Team can now seamlessly toggle between viewing past and future events & ' +
        'notices to stay organized.',
      'Say goodbye to outdated calendars, the date picker has been given a futuristic upgrade! You can ' +
        'now travel through time with just a few clicks.',
    ],
  };
  return getReleaseNoteObject(date, version, newFeatures);
}

function getReleaseNoteV2_24_0() {
  const date = '2023-03-01';
  const version = '2.24.0';
  const newFeatures = {
    'List 0': [
      'Booked users can now view their current booking status right on their dashboard. Also, we have ' +
        'email notifications in your inbox for the same.',
      'Account Managers and Relationship Managers can now view their team members leave in the member ' +
        'section of the dashboard.',
    ],
  };

  return getReleaseNoteObject(date, version, newFeatures);
}

function getReleaseNoteV2_25_0() {
  const date = '2023-03-15';
  const version = '2.25.0';
  const newFeatures = {
    'List 0': ['People Management Team can now add a tentative exit date for exiting Leapfrogger.'],
  };

  return getReleaseNoteObject(date, version, newFeatures);
}

function getReleaseNoteV2_26_0() {
  const date = '2023-04-10';
  const version = '2.26.0';
  const newFeatures = {
    Dashboard: [
      'My Allocations widget now includes your individual logged hours, pending worklogs, and missed attendance.',

      `Access info about your team's allocation and relationships with ease in the new "My Team" card.
      More features and functionalities coming soon over the next weeks to improve your experience. Stay tuned!`,
    ],
    Pulse: [
      'Exciting news! Our newest feedback-based system is here! Click the pulse icon by hovering over ' +
        'your team member in the "My Team" table or their profile. Let\'s get our pulses racing!',
    ],
  };

  return getReleaseNoteObject(date, version, newFeatures);
}

function getReleaseNoteV2_26_1() {
  const date = '2023-04-26';
  const version = '2.26.1';
  const newFeatures = {
    Dashboard: [
      `Users can now view their team member's today's attendance, pending/missing work logs, and ` +
        `planned leave from the "My Team" card.`,
      `Applicable users have the option to request for changing leave issuer and appraisers from the ` +
        `"My Team" card.`,
      "Removed the 'Quick Links' section. Don't worry, we plan to bring a revamped layout to view quick links soon.",
    ],
  };

  return getReleaseNoteObject(date, version, newFeatures);
}

function getReleaseNoteV2_26_2() {
  const date = '2023-06-07';
  const version = '2.26.2';
  const newFeatures = {
    Dashboard: [
      'Leapfroggers can now view the count of the people for whom they are responsible as Leave ' +
        'Issuer, Team Manager, Appraiser and Co-appraiser.',
    ],
    'Leave Issuer Change Request': [
      'Leapfroggers can now view an alert message where they can see the number of people for whom ' +
        'the selected leave issuer is responsible for.',
    ],
  };

  return getReleaseNoteObject(date, version, newFeatures);
}

function getReleaseNoteV2_27_0() {
  const date = '2023-06-27';
  const version = '2.27.0';
  const newFeatures = {
    Skills: [],
    'Paragraph 0': ['We are thrilled to introduce the new version of Skills.'],
    'List 0': [
      'Skills have been categorized into different sub-skills.',
      'We have introduced a skill verification process that involves both Team Manager and Directs.',
      'Team Manager has the ability to flag ratings assigned by Directs and suggest changes to the skill ratings.',
      'Team Manager can recommend the removal of certain skills if necessary.',
    ],
  };

  return getReleaseNoteObject(date, version, newFeatures);
}

function getReleaseNoteV2_28_0() {
  const date = '2023-07-17';
  const version = '2.28.0';
  const newFeatures = {
    'Profile / My Allocation': [],
    'Paragraph 0': ['As an Appraisee, you can now request for change of your Appraisers with ease!'],
    'List 0': [
      'Navigate to the "My Allocation" area in the Vyaguta Dashboard, hover over your Appraiser(s) ' +
        'profile icon, and click on the "Request for appraisers change" button.',
      'Alternatively, head over to your profile and find the "Request for appraisers change" button ' +
        'conveniently placed next to your allocations in the "Allocation" section.',
    ],
  };

  return getReleaseNoteObject(date, version, newFeatures);
}

function getReleaseNoteV2_29_0() {
  const date = '2023-08-16';
  const version = '2.29.0';
  const newFeatures = {
    'Exiting leapfroggers': [
      'Exiting leapfroggers will now receive email notifications outlining their roles and ' +
        'responsibilities to be transferred, two weeks prior to their anticipated exit date.',
    ],
  };

  return getReleaseNoteObject(date, version, newFeatures);
}

function getReleaseNoteV2_30_0() {
  const date = '2024-04-01';
  const version = '2.30.0';
  const newFeatures = {
    'Link Library': [
      'Access all relevant information effortlessly through the organized link library by simply ' +
        'clicking on the link library icon.',
    ],
  };

  return getReleaseNoteObject(date, version, newFeatures);
}

function getReleaseNoteV2_31_0() {
  const date = '2024-06-06';
  const version = '2.31.0';
  const confulenceLink =
    'https://lftechnology.atlassian.net/wiki/spaces/LEAP/pages/' + '4277043209/Median+Clock-in+Time+Calculation+Method';
  const newFeatures = {
    'Introducing Median Clock in Time!': [
      'Your median check-in time can now be viewed in the dashboard widget. This is calculated ' +
        'using your WiFi logs when you arrive at the Kathmandu office.',
      'You can view the last 30 days’ history through the widget.',
      `Your median check-in time is only visible to you.!`,
    ],
    'Paragraph 1': [
      'It’s just a friendly reminder to help keep us all on track!',
      'To learn more about these changes, please check out our {{Confluence Link,' +
        confulenceLink +
        "}}, where you'll find comprehensive information.",
    ],
  };
  return getReleaseNoteObject(date, version, newFeatures);
}

function getReleaseNoteV2_32_0() {
  const date = '2024-08-28';
  const version = '2.32.0';
  const newFeatures = {
    Assets: [
      'Leapfroggers can now view the list of the assets acquired in their profile ' + 'page under "Assets" tab.',
    ],
  };

  return getReleaseNoteObject(date, version, newFeatures);
}

function getReleaseNoteV2_32_1() {
  const date = '2024-08-30';
  const version = '2.32.1';
  const newFeatures = {
    'Leave Issuer change': [
      'The current leave issuer cannot be changed unless all pending leave requests and worklogs are approved.',
    ],
  };

  return getReleaseNoteObject(date, version, newFeatures);
}

function getReleaseNoteV2_33_0() {
  const date = '2024-09-25';
  const version = '2.33.0';
  const newFeatures = {
    'Search Leapfrogger': [
      'Introducing a global search feature that lets Leapfroggers quickly find any Leapfrogger ' +
        'across all modules with a convenient shortcut, improving navigation and streamlining access ' +
        'to their information.',
      'Keyboard shortcut for Windows/Linux: Ctrl + /',
      'Keyboard shortcut for macOS: cmd + /',
    ],
  };

  return getReleaseNoteObject(date, version, newFeatures);
}

function getReleaseNoteV2_34_0() {
  const date = '2024-10-24';
  const version = '2.34.0';
  const newFeatures = {
    'Work Status': [
      'User profiles now feature work status updates, including Work from Home (WFH), Work from ' +
        'Office (WFO), Pending Attendance, and Leave, along with office availability via Wi-Fi ' +
        'connectivity.',
    ],
  };

  return getReleaseNoteObject(date, version, newFeatures);
}

function getReleaseNoteV2_35_0() {
  const date = '2024-11-15';
  const version = '2.35.0';
  const newFeatures = {
    Profile: [
      "Project Managers, Team Managers, and Account Managers can now view each user's expected " +
        'weekly roster directly on their profile page. This feature displays the planned working ' +
        'shifts and working status for the current week.',
    ],
  };

  return getReleaseNoteObject(date, version, newFeatures);
}

function getReleaseNoteV2_35_1() {
  const date = '2025-01-29';
  const version = '2.35.1';
  const newFeatures = {
    Dashboard: [
      'Filters have been added to the My Team section, allowing users to filter their team members ' +
        "based on Today's Attendance.",
      'Click on any one of the status (Missing/Work Status/Leave) to filter the team members.',
    ],
    Profile: [
      'Team Managers, Appraisers, People Management and individuals themselves can view their ' +
        'Previous Experience on their profile page.',
    ],
    'Leave Issuer Change': [
      'While changing the leave issuer, only pending actions from the start of last month will be considered.',
    ],
  };

  return getReleaseNoteObject(date, version, newFeatures);
}

function getReleaseNoteV2_35_2() {
  const date = '2025-04-09';
  const version = '2.35.2';
  const newFeatures = {
    Profile: [
      'Users can now view their expected weekly roster directly from their profile page. This ' +
        'feature displays expected working shifts and roster for the current week.',
    ],
  };

  return getReleaseNoteObject(date, version, newFeatures);
}

function getReleaseNoteV2_36_0() {
  const date = '2025-08-20';
  const version = '2.36.0';
  const newFeatures = {
    Profile: [
      'An end date field has been added for employees whose employment status is set to "Sub-Contract."',
      "An automated email notification is now sent when an employee's employment status is updated " +
        'from Probation to Permanent.',
    ],
  };

  return getReleaseNoteObject(date, version, newFeatures);
}

function getReleaseNoteV3_0_0() {
  const date = '2026-06-12';
  const version = '3.0.0';
  const newFeatures = {
    Paragraph: [
      `We're excited to introduce Core v3.0.0, a significant modernization of the Vyaguta Core Module focused on improving maintainability, code quality, and overall system reliability.`,
    ],
    'Vyaguta Core': [
      `Front-end Migration: Upgraded from JavaScript to TypeScript for improved type safety, better developer experience, and enhanced code maintainability.`,
      `Back-end Migration: Transitioned from Express to NestJS, providing a more scalable, modular, and structured architecture.`,
      `Code Quality Improvements: Refactored and optimized the codebase to improve readability, consistency, and long-term maintainability.`,
      `Fixes and Improvement: Addressed multiple existing issues and technical debt to enhance the overall stability and performance of the application.`,
    ],
  };

  return getReleaseNoteObject(date, version, newFeatures);
}

export const releaseNotes = {
  ...getReleaseNoteV3_0_0(),
  ...getReleaseNoteV2_36_0(),
  ...getReleaseNoteV2_35_2(),
  ...getReleaseNoteV2_35_1(),
  ...getReleaseNoteV2_35_0(),
  ...getReleaseNoteV2_34_0(),
  ...getReleaseNoteV2_33_0(),
  ...getReleaseNoteV2_32_1(),
  ...getReleaseNoteV2_32_0(),
  ...getReleaseNoteV2_31_0(),
  ...getReleaseNoteV2_30_0(),
  ...getReleaseNoteV2_29_0(),
  ...getReleaseNoteV2_28_0(),
  ...getReleaseNoteV2_27_0(),
  ...getReleaseNoteV2_26_2(),
  ...getReleaseNoteV2_26_1(),
  ...getReleaseNoteV2_26_0(),
  ...getReleaseNoteV2_25_0(),
  ...getReleaseNoteV2_24_0(),
  ...getReleaseNoteV2_23_0(),
  ...getReleaseNoteV2_22_0(),
  ...getReleaseNoteV2_21_0(),
  ...getReleaseNoteV2_20_0(),
};
